// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=%27%23aaa%27 height=%2720%27 viewBox=%270 0 20 20%27 width=%2720%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M5.516 7.548l4.484 4.484 4.484-4.484 1.06 1.06-5.544 5.544-5.544-5.544z%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recipes-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px 0;
}

.recipes-title {
    font-size: 2rem;
    margin-bottom: 25px;
}

.recipes-grid {
    display: grid !important;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 25px;
    width: 100%;
}

.recipes-container {
    width: 100%;
}

.recipe-card-list {
    width: 100%;
    max-width: 100%;
}

/* DRAWER */

.add-step-btn {
    background: #6fb8af;
    color: white;
    padding: 8px 14px;
    border-radius: 8px;
    border: none;
    font-weight: 600;
    cursor: pointer;
    margin-bottom: 15px;
}

.step-editor-item {
    display: flex;
    gap: 12px;
    background: #f9fafb;
    padding: 12px;
    border-radius: 10px;
    margin-bottom: 12px;
    border: 1px solid #e5e7eb;
}

.step-drag-handle {
    cursor: grab;
    font-size: 1.4rem;
    padding: 6px;
    -webkit-user-select: none;
            user-select: none;
}

.step-editor-content {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.remove-step-btn {
    background: #dc2626;
    color: white;
    padding: 6px 10px;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    align-self: flex-start;
}

/* Dark mode */
.dashboard.dark .step-editor-item {
    background: #1f2937;
    border-color: #374151;
}

.dashboard.dark .step-drag-handle {
    color: #f3f4f6;
}

.dashboard.dark .remove-step-btn {
    background: #ef4444;
}


.recipes-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
}

.add-recipe-btn {
    background: #6fb8af;
    color: white;
    padding: 10px 16px;
    border-radius: 8px;
    border: none;
    font-weight: 600;
    cursor: pointer;
    transition: background .2s ease;
}

.add-recipe-btn:hover {
    background: #559e94;
}

.drawer-overlay {
    /*position: fixed;*/
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.45);
    display: flex;
    justify-content: flex-end;
    z-index: 999;
}

.drawer {
    width: 380px;
    height: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;
    box-shadow: -4px 0 16px rgba(0,0,0,0.2);
    animation: slideIn .25s ease forwards;
}

@keyframes slideIn {
    from { transform: translateX(100%); }
    to { transform: translateX(0); }
}

.drawer-input,
.drawer-textarea {
    width: 100%;
    padding: 10px;
    border-radius: 8px;
    border: 1px solid #ddd;
    font-size: 1rem;
}

.drawer-textarea {
    height: 100px;
    resize: vertical;
}

.drawer-submit {
    background: #6fb8af;
    color: white;
    padding: 10px 16px;
    border-radius: 8px;
    border: none;
    font-weight: 600;
    cursor: pointer;
    margin-top: 10px;
}

.drawer-submit:hover {
    background: #559e94;
}

.dashboard.dark .drawer {
    background: #1f2937;
    color: #f3f4f6;
}

.dashboard.dark .drawer-input,
.dashboard.dark .drawer-textarea {
    background: #111827;
    border: 1px solid #374151;
    color: #f3f4f6;
}

.dashboard.dark .drawer-submit {
    background: #6fb8af;
}

/* HEADER FIXE */
.drawer-header {
    padding: 20px;
    border-bottom: 1px solid #e5e7eb;
    flex-shrink: 0;
}

/* CONTENU SCROLLABLE */
.drawer-content {
    padding: 20px;
    overflow-y: auto;
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 20px; /* Ajoute un espace automatique entre les blocs */
}


/* FOOTER FIXE */
.drawer-footer {
    padding: 20px;
    border-top: 1px solid #e5e7eb;
    flex-shrink: 0;
}

.drawer-content h3 {
    margin-top: 10px;
    margin-bottom: 15px;
}


/* Carte recette */
.recipe-card-list {
    background: #fff;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(0,0,0,0.08);
    transition: transform .2s ease, box-shadow .2s ease;
}

.recipe-card-list:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 22px rgba(0,0,0,0.12);
}

.recipe-card-image {
    width: 100%;
    height: 180px;
    object-fit: cover;
}

.recipe-card-body {
    padding: 16px 20px;
}

.recipe-card-body h3 {
    margin: 0 0 10px;
    font-size: 1.2rem;
}

.recipe-button {
    display: inline-block;
    margin-top: 12px;
    padding: 8px 14px;
    background: #6fb8af;
    color: white;
    border-radius: 8px;
    text-decoration: none;
    font-weight: 600;
    transition: background .2s ease;
}

.recipe-button:hover {
    background: #559e94;
}

.filter-select {
    padding: 10px 14px;
    border-radius: 8px;
    border: 1px solid var(--border-color);
    background: var(--card-bg);
    color: var(--text-color);
    width: 200px;
    cursor: pointer;
    transition: 0.2s;
    appearance: none; /* enlève la flèche native */
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 12px center; /* espace la flèche */
    background-size: 14px;
    padding-right: 40px; /* espace pour la flèche */
}

/* Focus identique au search input */
.filter-select:focus {
    outline: none;
    border-color: var(--primary-color);
}

/* Hover optionnel */
.filter-select:hover {
    border-color: var(--primary-color);
}


.recipes-actions {
    display: flex;
    align-items: center;
    gap: 12px;
}




/* Dark mode */
.dashboard.dark .recipe-card-list {
    background: #1f2937;
    box-shadow: 0 4px 16px rgba(0,0,0,0.4);
}

.dashboard.dark .recipe-card-body h3,
.dashboard.dark .recipe-card-body p {
    color: #f3f4f6;
}

.dashboard.dark .recipe-button {
    background: #6fb8af;
}
`, "",{"version":3,"sources":["webpack://./src/styles/RecipeList.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,4DAA4D;IAC5D,SAAS;IACT,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA,WAAW;;AAEX;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,sBAAsB;AAC1B;;AAEA,cAAc;AACd;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,aAAa;IACb,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uCAAuC;IACvC,qCAAqC;AACzC;;AAEA;IACI,OAAO,2BAA2B,EAAE;IACpC,KAAK,wBAAwB,EAAE;AACnC;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,gCAAgC;IAChC,cAAc;AAClB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,gBAAgB;IAChB,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,SAAS,EAAE,iDAAiD;AAChE;;;AAGA,gBAAgB;AAChB;IACI,aAAa;IACb,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;;AAGA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uCAAuC;IACvC,mDAAmD;AACvD;;AAEA;IACI,2BAA2B;IAC3B,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,qCAAqC;IACrC,0BAA0B;IAC1B,wBAAwB;IACxB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB,EAAE,4BAA4B;IAC9C,yDAA2O;IAC3O,4BAA4B;IAC5B,sCAAsC,EAAE,qBAAqB;IAC7D,qBAAqB;IACrB,mBAAmB,EAAE,0BAA0B;AACnD;;AAEA,oCAAoC;AACpC;IACI,aAAa;IACb,kCAAkC;AACtC;;AAEA,oBAAoB;AACpB;IACI,kCAAkC;AACtC;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;;;;AAKA,cAAc;AACd;IACI,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".recipes-container {\r\n    max-width: 1200px;\r\n    margin: 0 auto;\r\n    padding: 20px 0;\r\n}\r\n\r\n.recipes-title {\r\n    font-size: 2rem;\r\n    margin-bottom: 25px;\r\n}\r\n\r\n.recipes-grid {\r\n    display: grid !important;\r\n    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\r\n    gap: 25px;\r\n    width: 100%;\r\n}\r\n\r\n.recipes-container {\r\n    width: 100%;\r\n}\r\n\r\n.recipe-card-list {\r\n    width: 100%;\r\n    max-width: 100%;\r\n}\r\n\r\n/* DRAWER */\r\n\r\n.add-step-btn {\r\n    background: #6fb8af;\r\n    color: white;\r\n    padding: 8px 14px;\r\n    border-radius: 8px;\r\n    border: none;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.step-editor-item {\r\n    display: flex;\r\n    gap: 12px;\r\n    background: #f9fafb;\r\n    padding: 12px;\r\n    border-radius: 10px;\r\n    margin-bottom: 12px;\r\n    border: 1px solid #e5e7eb;\r\n}\r\n\r\n.step-drag-handle {\r\n    cursor: grab;\r\n    font-size: 1.4rem;\r\n    padding: 6px;\r\n    user-select: none;\r\n}\r\n\r\n.step-editor-content {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n}\r\n\r\n.remove-step-btn {\r\n    background: #dc2626;\r\n    color: white;\r\n    padding: 6px 10px;\r\n    border-radius: 6px;\r\n    border: none;\r\n    cursor: pointer;\r\n    align-self: flex-start;\r\n}\r\n\r\n/* Dark mode */\r\n.dashboard.dark .step-editor-item {\r\n    background: #1f2937;\r\n    border-color: #374151;\r\n}\r\n\r\n.dashboard.dark .step-drag-handle {\r\n    color: #f3f4f6;\r\n}\r\n\r\n.dashboard.dark .remove-step-btn {\r\n    background: #ef4444;\r\n}\r\n\r\n\r\n.recipes-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 25px;\r\n}\r\n\r\n.add-recipe-btn {\r\n    background: #6fb8af;\r\n    color: white;\r\n    padding: 10px 16px;\r\n    border-radius: 8px;\r\n    border: none;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: background .2s ease;\r\n}\r\n\r\n.add-recipe-btn:hover {\r\n    background: #559e94;\r\n}\r\n\r\n.drawer-overlay {\r\n    /*position: fixed;*/\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0,0,0,0.45);\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    z-index: 999;\r\n}\r\n\r\n.drawer {\r\n    width: 380px;\r\n    height: 100%;\r\n    background: #fff;\r\n    display: flex;\r\n    flex-direction: column;\r\n    box-shadow: -4px 0 16px rgba(0,0,0,0.2);\r\n    animation: slideIn .25s ease forwards;\r\n}\r\n\r\n@keyframes slideIn {\r\n    from { transform: translateX(100%); }\r\n    to { transform: translateX(0); }\r\n}\r\n\r\n.drawer-input,\r\n.drawer-textarea {\r\n    width: 100%;\r\n    padding: 10px;\r\n    border-radius: 8px;\r\n    border: 1px solid #ddd;\r\n    font-size: 1rem;\r\n}\r\n\r\n.drawer-textarea {\r\n    height: 100px;\r\n    resize: vertical;\r\n}\r\n\r\n.drawer-submit {\r\n    background: #6fb8af;\r\n    color: white;\r\n    padding: 10px 16px;\r\n    border-radius: 8px;\r\n    border: none;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    margin-top: 10px;\r\n}\r\n\r\n.drawer-submit:hover {\r\n    background: #559e94;\r\n}\r\n\r\n.dashboard.dark .drawer {\r\n    background: #1f2937;\r\n    color: #f3f4f6;\r\n}\r\n\r\n.dashboard.dark .drawer-input,\r\n.dashboard.dark .drawer-textarea {\r\n    background: #111827;\r\n    border: 1px solid #374151;\r\n    color: #f3f4f6;\r\n}\r\n\r\n.dashboard.dark .drawer-submit {\r\n    background: #6fb8af;\r\n}\r\n\r\n/* HEADER FIXE */\r\n.drawer-header {\r\n    padding: 20px;\r\n    border-bottom: 1px solid #e5e7eb;\r\n    flex-shrink: 0;\r\n}\r\n\r\n/* CONTENU SCROLLABLE */\r\n.drawer-content {\r\n    padding: 20px;\r\n    overflow-y: auto;\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px; /* Ajoute un espace automatique entre les blocs */\r\n}\r\n\r\n\r\n/* FOOTER FIXE */\r\n.drawer-footer {\r\n    padding: 20px;\r\n    border-top: 1px solid #e5e7eb;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.drawer-content h3 {\r\n    margin-top: 10px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n\r\n/* Carte recette */\r\n.recipe-card-list {\r\n    background: #fff;\r\n    border-radius: 14px;\r\n    overflow: hidden;\r\n    box-shadow: 0 4px 16px rgba(0,0,0,0.08);\r\n    transition: transform .2s ease, box-shadow .2s ease;\r\n}\r\n\r\n.recipe-card-list:hover {\r\n    transform: translateY(-4px);\r\n    box-shadow: 0 6px 22px rgba(0,0,0,0.12);\r\n}\r\n\r\n.recipe-card-image {\r\n    width: 100%;\r\n    height: 180px;\r\n    object-fit: cover;\r\n}\r\n\r\n.recipe-card-body {\r\n    padding: 16px 20px;\r\n}\r\n\r\n.recipe-card-body h3 {\r\n    margin: 0 0 10px;\r\n    font-size: 1.2rem;\r\n}\r\n\r\n.recipe-button {\r\n    display: inline-block;\r\n    margin-top: 12px;\r\n    padding: 8px 14px;\r\n    background: #6fb8af;\r\n    color: white;\r\n    border-radius: 8px;\r\n    text-decoration: none;\r\n    font-weight: 600;\r\n    transition: background .2s ease;\r\n}\r\n\r\n.recipe-button:hover {\r\n    background: #559e94;\r\n}\r\n\r\n.filter-select {\r\n    padding: 10px 14px;\r\n    border-radius: 8px;\r\n    border: 1px solid var(--border-color);\r\n    background: var(--card-bg);\r\n    color: var(--text-color);\r\n    width: 200px;\r\n    cursor: pointer;\r\n    transition: 0.2s;\r\n    appearance: none; /* enlève la flèche native */\r\n    background-image: url(\"data:image/svg+xml;utf8,<svg fill='%23aaa' height='20' viewBox='0 0 20 20' width='20' xmlns='http://www.w3.org/2000/svg'><path d='M5.516 7.548l4.484 4.484 4.484-4.484 1.06 1.06-5.544 5.544-5.544-5.544z'/></svg>\");\r\n    background-repeat: no-repeat;\r\n    background-position: right 12px center; /* espace la flèche */\r\n    background-size: 14px;\r\n    padding-right: 40px; /* espace pour la flèche */\r\n}\r\n\r\n/* Focus identique au search input */\r\n.filter-select:focus {\r\n    outline: none;\r\n    border-color: var(--primary-color);\r\n}\r\n\r\n/* Hover optionnel */\r\n.filter-select:hover {\r\n    border-color: var(--primary-color);\r\n}\r\n\r\n\r\n.recipes-actions {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n}\r\n\r\n\r\n\r\n\r\n/* Dark mode */\r\n.dashboard.dark .recipe-card-list {\r\n    background: #1f2937;\r\n    box-shadow: 0 4px 16px rgba(0,0,0,0.4);\r\n}\r\n\r\n.dashboard.dark .recipe-card-body h3,\r\n.dashboard.dark .recipe-card-body p {\r\n    color: #f3f4f6;\r\n}\r\n\r\n.dashboard.dark .recipe-button {\r\n    background: #6fb8af;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
